export var AuthorizationConditionTemplate;
(function (AuthorizationConditionTemplate) {
    AuthorizationConditionTemplate["RESTRICTED_BY_CREATOR_ID"] = "{ \"createdByUserId\": \"{{currentUserId}}\" }";
})(AuthorizationConditionTemplate || (AuthorizationConditionTemplate = {}));
export var Role;
(function (Role) {
    Role["CUSTOMER_SUCCESS_MANAGER"] = "b0c0a62c-a701-485d-ae6e-0511dfb15e6c";
    Role["ACCOUNTING_MANAGER"] = "2a8ce305-de70-4bbe-996a-95895ecf2a06";
    Role["FULL_ADMIN"] = "0f450f90-278e-4bca-a2fc-e1276b77b135";
    Role["HR_OFFICER"] = "c94433f5-4de0-45e9-b38b-94ab5692ba65";
    Role["HR_MANAGER"] = "cfd0b361-a3e9-48b7-918d-1c77bb510806";
    Role["TA_MANAGER"] = "cefeb071-5c18-479b-81eb-03549e8eae60";
    Role["BASE_INVITEE"] = "b648291d-21b4-4b58-a2c3-6e2949d7a56b";
    Role["PERSON_READ_ALL"] = "8edc8bc9-88d6-4732-843c-0f4a2c41e6ba";
    Role["PERSON_READ_ONLY_OWN"] = "2b145add-bee7-40e2-96a5-ca7c6c2108f0";
    Role["PERSON_WRITE"] = "cc12c982-cf59-4243-a0af-753b9aebf41a";
    Role["PERSON_DELETE"] = "4a2a9b83-e49b-4eb2-a569-59421937d7fe";
    Role["TALENT"] = "0b3a266f-fad5-45cd-898e-c66191d0b1f0";
    Role["CANDIDATE_ASSESMENT"] = "3d2bac0e-0e2f-45ee-a14a-b5a0d745bca2";
})(Role || (Role = {}));
//# sourceMappingURL=index.js.map